import {
  Box,
  Button,
  Card,
  FormControl,
  InputLabel,
  MenuItem,
  MenuList,
  Select,
  TextField,
} from "@mui/material";
import { DataGrid, GridLinkOperator, GridToolbarQuickFilter } from "@mui/x-data-grid";
import React, { useState } from "react";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router";
import Swal from "sweetalert2";
import api from "../../../../components/services/api";
function QuickSearchToolbar() {
  return (
    <Box
      sx={{
        p: 2,
        width: '100%',
        display: 'flex',
        justifyContent: 'end'
      }}
    >

      <GridToolbarQuickFilter
        quickFilterParser={(searchInput) =>
          searchInput
            .split(',')
            .map((value) => value.trim())
            .filter((value) => value !== '')
        }
      />
    </Box>
  );
}
export default function Zone() {
  const [data, setdata] = useState([]);
  const [Zone, setZone] = useState([]);
  let { id } = useParams();
  const [selected, setSelected] = useState([]);
  const history = useHistory()
  
  const columns = [
    {
      field: "ContainerStockType",
      headerName: "STATUS",
      width: 100,
    },

    { field: "Voyage", headerName: "VoyIN", width: 150 },
    { field: "ContainerNo", headerName: "ContainerNo", width: 150 },
    // {
    //   field: "Size",
    //   headerName: "Size",
    //   width: 300,

    // },
    {
      field: "Booking",
      headerName: "Booking",
      width: 150,
    },
    {
      field: "ShipperRefNo",
      headerName: "Shipper Ref No",
      width: 150,
    },

    {
      field: "Size",
      headerName: "Size",
      width: 100,
    },
    {
      field: "GradeRequested",
      headerName: "Grade",
      width: 150,
    },
    {
      field: "SurveyGrade",
      headerName: "Survey Grade",
      width: 170,
      renderCell: (params) => {
        return (
          <>
            {/* <TextField
              label="Survey Grade"
              size="small"
              value={params?.row?.SurveyGrade || ''}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onChange={(e) => {
                const select = data?.map((y) => {
                  y.SurveyGrade =
                    y?.SurveyGrade === params?.row?.SurveyGrade
                      ? e.target.value
                      : y?.SurveyGrade;
                  return y;
                });

                setdata([...select]);
              }}
            /> */}
            <FormControl sx={{ width: "100%" }} size="small">
              <InputLabel>Survey Grade</InputLabel>
              <Select
                label="Survey Grade"
                style={{
                  width: "100%",
                }}
                // disabled={params?.row?.RepairStatus === 'Processing' ? true : params?.row?.RepairStatus === 'Done' ? true : false}
                value={params?.row?.Grade || ''}
                // onChange={(e) => {
                //   const select = data?.map((y) => {
                //     y.Grade =
                //       y?.Grade === params?.row?.Grade
                //         ? e.target.value
                //         : y?.Grade;
                //     return y;
                //   });
  
                //   setdata([...select]);
                // }}
                onChange={(e) => {
                  const select = data?.map((y) => {
                    y.Grade =
                      y?.ContainerNo === params?.row?.ContainerNo
                        ? e.target.value
                        : selected.filter(
                          (x) => x.ContainerNo === y?.ContainerNo
                        ).length > 0
                          ? e.target.value
                          : y?.Grade;
                    return y;
                  });

                  setdata([...select]);
                }}
              >
                <MenuItem value='A'>A</MenuItem>
                <MenuItem value='B'>B</MenuItem>
                <MenuItem value='C'>C</MenuItem>
                <MenuItem value='D'>D</MenuItem>
              </Select>
            </FormControl>
          </>
        );
      },
    },
    {
      field: "Seal",
      headerName: "Survey Status",
      width: 200,
      renderCell: (params) => {
        return (
          <>
            <FormControl sx={{ width: "100%" }} size="small">
              <InputLabel>Survey Status</InputLabel>
              <Select
                label="Survey Status"
                style={{
                  width: "100%",
                }}
                disabled={params?.row?.RepairStatus === 'Processing' ? true : params?.row?.RepairStatus === 'Done' ? true : false}
                value={params?.row?.SurveyStatus || ''}
                onChange={(e) => {
                  const select = data?.map((y) => {
                    y.SurveyStatus =
                      y?.ContainerNo === params?.row?.ContainerNo
                        ? e.target.value
                        : selected.filter(
                          (x) => x.ContainerNo === y?.ContainerNo
                        ).length > 0
                          ? e.target.value
                          : y?.SurveyStatus;
                    return y;
                  });

                  setdata([...select]);
                }}
              >
                <MenuItem value='Complete'>Complete</MenuItem>
                <MenuItem value='Damage'>Damage</MenuItem>
              </Select>
            </FormControl>
          </>
        );
      },
    },
    {
      field: "JobOrderNo",
      headerName: "Job Order No",
      width: 150,
    },
    {
      field: "RepairStatus",
      headerName: "Repair Status",
      width: 200,
    },
    {
      field: "Loading",
      headerName: "Loading",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            <FormControl sx={{ width: "100%" }} size="small">
              <InputLabel>Loading</InputLabel>
              <Select
                label="Loading"
                style={{
                  width: "100%",
                }}
                InputLabelProps={{ shrink: true }}
                value={params?.row?.ToCargoStatus || ""}
                onChange={(e) => {
                  const select = data?.map((y) => {
                    y.ToCargoStatus =
                      y?.ContainerNo === params?.row?.ContainerNo
                        ? e.target.value
                        : selected.filter(
                          (x) => x.ContainerNo === y?.ContainerNo
                        ).length > 0
                          ? e.target.value
                          : y?.ToCargoStatus;
                    if (e.target.value === "Loading In") {
                      y.ToZone =  y?.ContainerNo === params?.row?.ContainerNo
                      ? null : y.ToZone
                      y.ToBay =  y?.ContainerNo === params?.row?.ContainerNo
                      ? null : y.ToBay
                      y.ToRow =  y?.ContainerNo === params?.row?.ContainerNo
                      ? null : y.ToRow
                      y.ToTier =  y?.ContainerNo === params?.row?.ContainerNo
                      ? null : y.ToTier
                   
                    }
                      return y;
                  });
                  setdata([...select]);
                }}
              >
                <MenuItem value="Discharge In">Discharge</MenuItem>
                <MenuItem value="Loading In">Loading</MenuItem>
              </Select>
            </FormControl>
          </>
        );
      },
    },
    {
      field: "WagonNo",
      headerName: "Wagon No",
      width: 150,
    },
    {
      field: "Zone",
      headerName: "Zone",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            <FormControl sx={{ width: "100%" }} size="small">
              <InputLabel>Zone</InputLabel>
              <Select
                label="Zone"
                style={{
                  width: "100%",
                }}
                disabled={params?.row?.ToCargoStatus === "Loading In" ? true : false }
                value={params?.row?.ToZone || ""}
                onChange={(e) => {
                  const select = data?.map((y) => {
                    y.ToZone =
                      y?.ContainerNo === params?.row?.ContainerNo
                        ? e.target.value
                        : selected.filter(
                          (x) => x.ContainerNo === y?.ContainerNo
                        ).length > 0
                          ? e.target.value
                          : y?.ToZone;
                    return y;
                  });
                  setdata([...select]);
                }}
              >
                {Zone?.map((y) => (
                  <MenuItem value={y?.ZoneName}>{y?.ZoneName}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        );
      },
    },

    {
      field: "Bay",
      headerName: "Bay",
      width: 100,
      renderCell: (params) => {
        return (
          <>
            <TextField
              label="Bay"
              size="small"
              disabled={params?.row?.ToCargoStatus === "Loading In" ? true : false }
              value={params?.row?.ToBay || ''}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onChange={(e) => {
                const select = data?.map((y) => {
                  y.ToBay =
                    y?.ContainerNo === params?.row?.ContainerNo
                      ? e.target.value
                      : y?.ToBay;
                  return y;
                });

                setdata([...select]);
              }}
            />
          </>
        );
      },
    },
    {
      field: "Row",
      headerName: "Row",
      width: 100,
      renderCell: (params) => {
        return (
          <>
            <TextField
              label="Row"
              size="small"
              value={params?.row?.ToRow || ''}
              disabled={params?.row?.ToCargoStatus === "Loading In" ? true : false }
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onChange={(e) => {
                const select = data?.map((y) => {
                  y.ToRow =
                    y?.ContainerNo === params?.row?.ContainerNo
                      ? e.target.value
                      : y?.ToRow;
                  return y;
                });

                setdata([...select]);
              }}
            />
          </>
        );
      },
    },
    {
      field: "Tier",
      headerName: "Tier",
      width: 100,
      renderCell: (params) => {
        return (
          <>
            <TextField
              label="Tier"
              size="small"
              value={params?.row?.ToTier || ''}
              disabled={params?.row?.ToCargoStatus === "Loading In" ? true : false }
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onChange={(e) => {
                const select = data?.map((y) => {
                  y.ToTier =
                    y?.ContainerNo === params?.row?.ContainerNo
                      ? e.target.value
                      : y?.ToTier;
                  return y;
                });

                setdata([...select]);
              }}
            />
          </>
        );
      },
    },
    // {
    //   field: "",
    //   headerName: "Repair Status",
    //   width: 300,
    // }
  ];
  const getdata = async () => {
    try {
      const data = await api.get(`api/containermovement/inbound/detail/${id}`);
      const res = data?.data;
      setdata(res?.Container);
      setZone(res?.Zone);
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    getdata();
  }, [id]);

  const handlesun = () => {
    const body = {
      VoyNo: id,
      ContainerList: data,
    };
    api.post(`/api/containermovement/inbound/update/container`, body).then((res) => {
      if (res?.meta?.status == true) {
        Swal.fire({
          title: `${res.meta.message}`,
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            getdata()
          }
        })
      }
      }
    )
  };
  const handleDelete = () => {
    const body = {
      VoyNo: id,
      ContainerList: selected,
    };
    Swal.fire({
      title: "ต้องการลบหรือไม่ ?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: "ลบ",
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        api.post(`/api/containermovement/inbound/delete/container`, body).then((res) => {
          if (res?.meta?.status == true) {
            Swal.fire({
              title: `${res.meta.message}`,
              icon: 'success',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                getdata()
              }
            })
          }
          }
        )
      } 
    });
   
  };

  return (
    <>
      <Box
        sx={{
          height: 650,
          width: "100%",
        }}
      >
        <DataGrid
          getRowId={(r) => r.ContainerNo}
          rows={data}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          hideFooterSelectedRowCount
          disableColumnFilter
          disableColumnMenu
          checkboxSelection
          disableSelectionOnClick
          // isRowSelectable={(params) => params.row.ToCargoStatus !== "Loading In"}
          onSelectionModelChange={(ids) => {
            const selectedIDs = new Set(ids);
            const selectedRows = data?.filter((row) =>
              selectedIDs.has(row.ContainerNo)
            );
            setSelected(selectedRows);
          }}
          initialState={{
            filter: {
              filterModel: {
                items: [],
                quickFilterLogicOperator: GridLinkOperator.Or,
              },
            },
          }}
          components={{ Toolbar: QuickSearchToolbar }}
        />
      </Box>
      <Box sx={{ display: "flex", marginTop: "25px" }}>
        <Button
          sx={{ width: 80 }}
          type="button"
          variant="outlined"
          style={{
            color: "#80c340",
            borderColor: "#80c340",
            marginRight: "10px",
          }}
          onClick={history.goBack}
        >
          close
        </Button>
        <Button
          sx={{ width: 80 }}
          variant="contained"
          style={{
            background: "#80c340",
            borderColor: "#80c340",
            marginRight: "10px",
          }}
          onClick={handlesun}
        >
          Save
        </Button>
        <Button
          sx={{ width: 80 }}
          variant="contained"
          style={{
            background: "red",
            borderColor: "red",
            marginRight: "10px",
          }}
          disabled={selected.length === 0}
          onClick={handleDelete}
        >
          Delete
        </Button>
      </Box>
    </>
  );
}
